module.exports = __webpack_public_path__ + "img/Everyman-clock@2x.b488404a.png";